import slugify from 'slugify';

export default ({ app }, inject, store) => {
    inject('scrollToElement', (selector, offset = 150, mode = 'smooth') => {
        const targetScrollY = document.querySelector(selector).getBoundingClientRect().top + window.scrollY - offset;

        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({ left: 0, top: targetScrollY, behavior: mode });
        } else {
            window.scrollTo(0, targetScrollY);
        }
    });
    inject('downloadFile', (url, fileName) => {
        fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
            .then((res) => res.blob())
            .then((res) => {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', fileName);
                const href = URL.createObjectURL(res);
                aElement.href = href;
                aElement.setAttribute('target', '_blank');
                aElement.click();
                URL.revokeObjectURL(href);
            });
    });
    inject('setImage', (image, folder, prod) => {
        if (prod) {
            return require(`~/assets/images/${folder}${image}`);
        } else {
            return require(`~/assets/images/dev/${folder}${image}`);
        }
    });
    inject('setBanner', (banners, location) => {
        return banners.find((item) => item.name === location);
    });
    inject('slugify', (payload) => {
        return slugify(payload.toLowerCase());
    });
    inject('scrollToTop', () => {
        window.scrollTo(0, -76);
    });
    inject('formatCurrency', (number) => {
        if (typeof number !== 'number' || !number) return;
        return number.toLocaleString('hu-HU', {
            style: 'currency',
            currency: 'HUF',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    });
};
